import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const variants = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94], staggerChildren: 0.15 } },
};

export default function SlideWrapper({ children, id, className = '', refCallback, fullBleed = false, indigoTheme = true }) {
  const { ref: inViewRef, inView } = useInView({ threshold: 0.15, triggerOnce: true });

  const setRefs = (el) => {
    inViewRef(el);
    if (refCallback) refCallback(el);
  };

  return (
    <section
      ref={setRefs}
      id={id}
      className={`${fullBleed
        ? 'min-h-[100svh] w-full flex items-center justify-center relative overflow-hidden'
        : 'min-h-[80vh] w-full flex items-center justify-center px-4 py-12 md:py-20 relative overflow-hidden'} ${className} ${indigoTheme ? 'theme-slide' : ''}`}
    >
      <motion.div
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={variants}
        className={fullBleed ? 'w-full' : 'max-w-7xl w-full mx-auto'}
      >
        {children}
      </motion.div>
    </section>
  );
}
